import { Fragment, useContext, useState, useEffect } from "react";
import { RoleContext } from '../../contexts/RoleContext';
import { Button, Form, Modal } from "react-bootstrap";

const UpdateRoleModal = () => {

    const {
        roleState: { role },
        showUpdateRoleModal,
        setShowUpdateRoleModal,
        updateRole,
        setShowToast,
        setRole,
    } = useContext(RoleContext)

    // State
    const [updatedRole, setUpdatedRole] = useState(role)
    useEffect( () => setUpdatedRole(role), [role] )

    const { name, display_name, description } = updatedRole

    const onChange = event => setUpdatedRole( {...updatedRole, [event.target.name]: event.target.value } )

    const onSubmit = async event => {
        event.preventDefault()
        const response = await updateRole(updatedRole)
        if (response.status === 200) {
            setRole(updatedRole)
            closeDialog()
            setShowToast({show: true, message: 'Updated successful!', type: 'success'})
            return
        }
        
        setShowToast({show: true, message: response.error && response.error.ErrorCode? response.error.ErrorCode: 'Update failed!', type: 'danger'})
    }

    const closeDialog = () => {
        setUpdatedRole(role)
        setShowUpdateRoleModal(false)
    }

    return (
        <Fragment>
            <Modal show={showUpdateRoleModal} onHide={closeDialog}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Update Role
                    </Modal.Title>
                </Modal.Header>
                <Form onSubmit={onSubmit}>
                    <Modal.Body>
                        <div className="form-group">
                            <label>Name</label>
                            <input className="form-control" placeholder="Enter Name Permission" name='name' value={name} onChange={onChange} required aria-describedby='address-help' />
                            <Form.Text id='address-help' muted>Required</Form.Text>
                        </div>
                        <div className="form-group">
                            <label>Display Name</label>
                            <input className="form-control" placeholder="Display Name Permission" name='display_name' value={display_name} onChange={onChange} required aria-describedby='display-help' />
                            <Form.Text id='display-help' muted>Required</Form.Text>
                        </div>
                        <div className="form-group">
                            <label>Description</label>
                            <textarea className="form-control" placeholder="Description" rows="3" name='description' value={description} spellCheck="false" onChange={onChange}></textarea>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className="btn btn-danger btn-with-icon" variant='secondary' onClick={closeDialog}><i className="fe fe-x-circle"></i> Cancel</Button>
                        <Button className="btn btn-primary btn-with-icon" variant='primary' type='submit'><i className="fe fe-save"></i> Save!!!</Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </Fragment>
    )
}

export default UpdateRoleModal
